<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card>
      <card-content>
        <validation-observer ref="validator">
          <v-row dense class="mt-4">
            <v-col cols="12"
              ><h2>{{ "Доля ширины (от 1 до 12)" }}</h2></v-col
            >
          </v-row>
          <v-row
            v-for="(title, breakpoint) in breakpoints"
            :key="breakpoint"
            dense
            class="align-center mt-4"
          >
            <v-col cols="4" class="text-right">{{ title }}</v-col>
            <v-col style="min-width: 95px; max-width: 95px;">
              <validation-provider
                v-slot="{ errors }"
                rules="oneOf:1,2,3,4,5,6,7,8,9,10,11,12"
              >
                <v-text-field
                  v-model="rowSettings[breakpoint].value"
                  dense
                  outlined
                  :error-messages="errors"
                  hide-details
                  maxlength="2"
                  :disabled="rowSettings[breakpoint].auto"
                  :suffix="
                    rowSettings[breakpoint].auto ||
                    !rowSettings[breakpoint].value
                      ? ''
                      : '/ 12'
                  "
                />
              </validation-provider>
            </v-col>
            <v-col v-if="breakpoint != ''">
              <v-checkbox
                v-model="rowSettings[breakpoint].auto"
                label="Авто-ширина"
                dense
                outlined
                hide-details
                class="mt-0 pt-0"
                @change="onCheckboxChange(breakpoint)"
              />
            </v-col>
          </v-row>
        </validation-observer>
      </card-content>
      <card-actions>
        <v-btn
          id="form-btn-remove"
          color="danger"
          depressed
          outlined
          @click="$emit('remove')"
        >
          {{ "Удалить" }}
        </v-btn>
        <v-spacer />
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          {{ "Отменить" }}
        </v-btn>
        <v-btn id="form-btn-save" color="primary" depressed @click="save">
          Сохранить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
const breakpointsDict = () => ({
  "": "Phone (xs)",
  "-sm": "Tablet (sm)",
  "-md": "Laptop (md)",
  "-lg": "Desktop (lg)",
  "-xl": "Ultra-wide (xl)"
});

const rowSettingsFactory = breakpoints => {
  return Object.keys(breakpoints).reduce((ind, item) => {
    ind[item] = { auto: false, value: null };
    return ind;
  }, {});
};

export default {
  name: "RowSettingsDialog",

  model: {
    prop: "open",
    event: "change"
  },

  props: {
    open: Boolean,
    classes: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      breakpoints: breakpointsDict(),
      rowSettings: rowSettingsFactory(breakpointsDict())
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.reset();
        this.load();
      } else {
        this.reset();
        this.$emit("close");
      }
    }
  },

  methods: {
    async save() {
      if (!(await this.$refs.validator.validate())) return;
      const classes = Object.entries(this.rowSettings).reduce(
        (classes, entry) => {
          if (entry[1].auto) {
            classes.push(`col${entry[0]}`);
          } else if (entry[1].value) {
            classes.push(`col${entry[0]}-${entry[1].value}`);
          }
          return classes;
        },
        []
      );
      this.$emit("apply", classes);
      this.dialog = false;
    },

    async load() {
      this.classes.split(" ").forEach(item => {
        if (["", "col", "aunfcol"].includes(item)) {
          return;
        }
        let breakpoint = "";
        let amount = null;

        const parts = item.split("-");
        if (parts.length == 3) {
          // breakpoint + amount
          breakpoint = `-${parts[1]}`;
          amount = parts[2];
        } else if (isNaN(parseInt(parts[1]))) {
          // breakpoint
          breakpoint = `-${parts[1]}`;
          amount = "";
        } else {
          // amount
          amount = parts[1];
        }

        if (!this.rowSettings[breakpoint]) {
          console.log(breakpoint);
        }

        this.rowSettings[breakpoint].value = amount;
        this.rowSettings[breakpoint].auto = amount === "";
      });
    },

    reset() {
      this.$set(this, "rowSettings", rowSettingsFactory(this.breakpoints));
      if (this.$refs.validator) this.$refs.validator.reset();
    },

    onCheckboxChange(breakpoint) {
      if (this.rowSettings[breakpoint].auto) {
        this.rowSettings[breakpoint].value = "";
      }
    }
  }
};
</script>
